import * as UnifyHeight from './UnifyHeight';
import * as DOMHelpers from './DOMHelpers';
import * as Browser from './Browser';

export function applyTo(selector) {
    initialize(selector);
}

function initialize(selector) {
    initializeButton(selector);
}

function initializeButton(selector) {
    document.addEventListener('click', function(event) {
        console.log('EndlessList: Click');
        let target = event.target || event.srcElement;

        while(target !== null && target.matches('[data-endless-list-block="next"] button') === false) {
            target = target.parentElement;
        }

        if(target) {
            console.log('EndlessList: found');
            console.log('444');
            event.preventDefault();
            console.log(target.hasOwnProperty('endlessListParent'));
            if(target.hasOwnProperty('endlessListParent') === false) {
                target.endlessListParent = DOMHelpers.findParentBySelector(target, selector);
            }
            console.log('test');
            let nextPageLink = target.endlessListParent.querySelector('.next-page-link').getAttribute('href');
            loadOthers(nextPageLink, target.endlessListParent);
        }
    });
}

function startSpinner() {
    console.log('Spinner start');
    let spinner = document.querySelector('[data-spinner]');

    if(spinner) {
        spinner.classList.remove('d-none');
    }
}

function stopSpinner() {
    console.log('Spinner stop');
    let spinner = document.querySelector('[data-spinner]');
    if(spinner) {
        spinner.classList.add('d-none')
    }
}

function loadOthers(nextLink, element) {
    startSpinner();
    fetch(nextLink).then(response => {
        return response.text();
    }).then(response => {
        return new DOMParser().parseFromString(response, 'text/html')
    }).then(response => {
        let blocks = response.querySelectorAll('[data-endless-list="'+element.dataset.endlessList+'"] [data-endless-list-block]');

        blocks.forEach(function(block) {
            let blockName = block.getAttribute('data-endless-list-block');
            let blockSelector = '[data-endless-list-block="'+blockName+'"]';
            let originalBlock = element.querySelector(blockSelector);
            if(blockName === 'items-list') {
                originalBlock.innerHTML = originalBlock.innerHTML+block.innerHTML;
            } else {
                originalBlock.innerHTML = block.innerHTML;
            }
        });

        UnifyHeight.applyTo('.js-unify-height');
        UnifyHeight.applyDataAttribute();
    }).then(response => {
        Browser.changeUrl(nextLink);
    }).then(response => {
        stopSpinner()
        return response;
    });
}
